export default __webpack_public_path__ + "static/media/logout-icon.8590644c.svg";